import { LinkType } from "interfaces/content";

export const getStringWithLineBreak = (value?: string) => {
  if (!value) return undefined;

  return String(value).replaceAll(/(?:\\[rn]|[\r\n]|<br\s*\/?>)+/g, "\n");
};

export const parseToLinkType = (value: string, type: "email" | "phone"): LinkType => {
  return {
    type: "link",
    text: value,
    href: type === "email" ? `mailto:${value}` : `tel:${value}`,
  };
};
